import { render, staticRenderFns } from "./OpeningCredits.vue?vue&type=template&id=9767a9a2&scoped=true"
import script from "./OpeningCredits.vue?vue&type=script&lang=js"
export * from "./OpeningCredits.vue?vue&type=script&lang=js"
import style0 from "./OpeningCredits.vue?vue&type=style&index=0&id=9767a9a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9767a9a2",
  null
  
)

export default component.exports